import {
  Add_Projects,
  Get_All_Projects,
  Get_Error,
  Update_Project,
  Get_One_Project_Data,
  Get_Top_Projects_and_Analayse_For_Dashboard_Type
} from '../Types';

const intial = {
  Projects: [],
  loading: true,
};

const ProjectsReducers = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Projects:
      return {
        ...state,
        Projects: action.payload,
        loading: false,
      };
    case Add_Projects:
      return {
        Projects: action.payload,
        loading: false,
      };
    case Update_Project:
      return {
        Projects: action.payload,
        loading: false,
      };
    case Get_One_Project_Data:
      return {
        Projects: action.payload,
        loading: false,
      };
     case Get_Top_Projects_and_Analayse_For_Dashboard_Type:
      return{
    GetTop_ProjectsForDashboard:action.payload,
    loading:false,
    }
    case Get_Error:
      return {
        loading: true,
        Projects: action.payload,
      };
    default:
      return state;
  }
};

export default ProjectsReducers;
